export const augustAbbreviatedLowercase = "JKnCbb";
export default {augustAbbreviatedLowercase};